export function normalizeFormationForRequest(formation) {
    return {
        id: formation.id,
        formationId: formation.formationId || formation.id,
        titre: formation.titre || formation.nom || formation.title,
        nom: formation.nom || formation.titre || formation.title,
        description: formation.description || "",
        categorie: formation.categorie || formation.category || formation.domaine || "",
        duree: formation.duree || formation.duration || "",
        source: formation.source || "PLAN_DEVELOPPEMENT",
    };
}

export function buildFormationCardFromCampaign(formation) {
    return {
        id: formation.id,
        formationId: formation.id,
        titre: formation.nom,
        nom: formation.nom,
        description: formation.description || "",
        category: formation.domaineNom || formation.themeNom || "",
        duration: formation.duration ? `${formation.duration} ${formation.typeDuree || ""}`.trim() : "",
        level: formation.niveaux || "",
        image: formation.picture || null,
        badge: "Formation",
        disabled: !!formation.alreadyRequested,
        buttonLabel: formation.alreadyRequested ? "Deja demandee" : "Demander",
    };
}

export function resolvePlanDeveloppementImage(card) {
    if (card?.image) return card.image;
    const content = `${card?.titre || card?.nom || card?.title || ""} ${card?.category || card?.categorie || ""}`.toLowerCase();
    const match = PLAN_DEVELOPPEMENT_IMAGE_BY_KEYWORD.find((entry) => entry.keywords.some((keyword) => content.includes(keyword)));
    return match?.image || DEFAULT_PLAN_DEVELOPPEMENT_IMAGE;
}
const PLAN_DEVELOPPEMENT_IMAGE_BY_KEYWORD = [
    { keywords: ["leadership", "management"], image: "https://images.unsplash.com/photo-1552664730-d307ca884978" },
    { keywords: ["projet", "project", "organisation"], image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40" },
    { keywords: ["communication", "soft skills", "collaboration"], image: "https://images.unsplash.com/photo-1521737604893-d14cc237f11d" },
    { keywords: ["temps", "priorite", "efficacite"], image: "https://images.unsplash.com/photo-1516321318423-f06f85e504b3" },
];

const DEFAULT_PLAN_DEVELOPPEMENT_IMAGE = PLAN_DEVELOPPEMENT_IMAGE_BY_KEYWORD[0].image;
